
import { ReactNode } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/sections/Footer";
import { EnhancedSEO } from "@/components/seo/EnhancedSEO";

interface LandingPageTemplateProps {
  title: string;
  description: string;
  keywords: string[];
  canonicalUrl: string;
  children: ReactNode;
  ogImage?: {
    url: string;
    alt: string;
  };
  schemaType?: "service" | "article" | "product";
  schemaData?: Record<string, any>;
}

export const LandingPageTemplate = ({
  title,
  description,
  keywords,
  canonicalUrl,
  children,
  ogImage = {
    url: "/og-image.png",
    alt: "edgefi cybersecurity services"
  },
  schemaType = "service",
  schemaData = {}
}: LandingPageTemplateProps) => {
  return (
    <div className="min-h-screen bg-white">
      <EnhancedSEO
        title={`${title} | edgefi`}
        description={description}
        keywords={keywords}
        canonicalUrl={canonicalUrl}
        ogType="website"
        image={ogImage}
        organization={{
          name: "edgefi",
          logo: "/lovable-uploads/3faf62f0-dd43-43cc-82c2-9329f89d269f.png",
          url: "https://edgefi.com",
          sameAs: [
            "https://twitter.com/edgefi",
            "https://www.linkedin.com/company/edgefi",
            "https://www.facebook.com/edgefi"
          ]
        }}
      />
      
      <Navbar />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};
